import { Button } from 'react-bootstrap'
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { canvasConnect as endpoints } from '@URLS'
import ButterToast, { Cinnamon } from 'butter-toast'
import { LoadingWave } from '../../components'

const ConnectResourceComp = props => {
  const [currentState, dispatch] = useStateValue()
  const [loading, setLoading] = useState(false)
  let contextId = window.location.pathname.split('/')[4]
  useEffect(() => {
    async function getConnectResourceData(contextId, dispatch) {
      try {
        let resp = await client.get(endpoints.getInstructorData({ contextId }))
        await dispatch({
          type: 'updateInstructorData',
          payload: {
            ...resp.data,
          },
        })
      } catch (err) {
        console.log(err)
        ButterToast.raise({
          content: (
            <Cinnamon.Crisp
              title="Error"
              content={err.response.data.error}
              scheme={Cinnamon.Crisp.SCHEME_RED}
              icon={<i className="far fa-thumbs-down fa-3x" />}
            />
          ),
        })
      }
    }
    getConnectResourceData(contextId, dispatch)
  }, [])

  let resetApp = () => {
    dispatch({
      type: 'reset',
    })
    props.history.goBack()
  }

  const createConnection = async (cnumToCopy, history) => {
    setLoading(true)
    try {
      setLoading(true)
      await client.post(endpoints.createNewCourse(), {
        source_coursenum: cnumToCopy,
        contextId: contextId,
      })
      setLoading(false)
      history.push(
        `/links/canvas_connect.instructor_setup/-/${contextId}${window.location.search}`
      )
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Success"
            content="Your resource has been successfully linked."
            scheme={Cinnamon.Crisp.SCHEME_GREEN}
            icon={<i className="far fa-thumbs-up fa-3x" />}
          />
        ),
      })
    } catch (err) {
      setLoading(false)
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={err.response.data.error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
        sticky: true,
      })
    }
  }

  if (loading) {
    return (
      <React.Fragment>
        <h2>Copying and Connecting Selected Resource</h2>
        <LoadingWave />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      {currentState.connectedCourses.length === 0 && (
        <div className="ml-5">
          <div className="ml-5">
            <h2>Welcome, {currentState.instrFirstName}</h2>
            <h4>Select a MyEducator resource to copy and connect to Canvas.</h4>
          </div>
        </div>
      )}
      <div className="ml-5 mt-4 d-flex justify-content-between">
        {currentState.instrCourses.length > 0 ? (
          <div className="ml-5">
            <select
              onChange={event =>
                dispatch({
                  type: 'coursenumToCopy',
                  coursenumToCopy: event.target.value,
                })
              }
            >
              <option value="">Select an available resource</option>
              {currentState.instrCourses.map((childCourse, i) => (
                <option key={i} value={childCourse.coursenum}>
                  {`${childCourse.course_title} Created: ${childCourse.create_date}`}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div className="ml-5">
            <p>
              The email address <i>{currentState.instrEmail}</i> does not belong
              to any MyEducator resources.
            </p>
            <p>
              Please contact your MyEducator representative or email us at{' '}
              <a href="mailto:support@myeducator.com">support@myeducator.com</a>{' '}
              for assistance.
            </p>
          </div>
        )}
        {currentState.connectedCourses.length > 0 && (
          <div className="btn btn-link text-dec-none" onClick={resetApp}>
            <div className="fas fa-times fa-fw" /> Cancel
          </div>
        )}
      </div>
      <div className="ml-5">
        <Button
          disabled={currentState.coursenumToCopy === ''}
          className="btn btn-success btn-myed btn-success-myed ml-5 mt-4"
          onClick={() =>
            createConnection(currentState.coursenumToCopy, props.history)
          }
        >
          Create Connection
        </Button>
      </div>
    </React.Fragment>
  )
}

ConnectResourceComp.propTypes = {
  history: PropTypes.object.isRequired,
}

export const ConnectResource = withRouter(ConnectResourceComp)
